import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldBase } from '@nagel-types';

export const CONTAINER_FIELD_TYPES = ['section', 'row'];

@Injectable({
    providedIn: 'root'
})
export class FieldControlService {
    getFormControl(field: FieldBase<unknown>) {
        return new FormControl(
            { value: field.value, disabled: field.disabled },
            field.validators || []
        );
    }

    transformInternalFields(
        mappedFields: Record<string, unknown>,
        field: FieldBase<unknown>,
        mapHandler: (currentField: FieldBase<unknown>) => unknown
    ) {
        if (!CONTAINER_FIELD_TYPES.includes(field.controlType)) {
            mappedFields[field.key] = mapHandler(field);
        }

        if (field.internalFields && field.internalFields.length > 0) {
            field.internalFields.forEach((internalField) => {
                this.transformInternalFields(mappedFields, internalField, mapHandler);
            });
        }
    }

    mapInternalFields(
        fields: FieldBase<unknown>[] = [],
        mapHandler: (field: FieldBase<unknown>) => unknown
    ) {
        const mappedFields: Record<string, unknown> = {};

        fields.forEach((field) => {
            this.transformInternalFields(mappedFields, field, mapHandler);
        });

        return mappedFields;
    }
}